import { AxiosError } from '@price-for-profit/micro-services';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'routing';
import { MUTATION_KEYS } from 'shared/constants';
import { useService } from 'shared/providers';
import { MassActionRevisedPriceProps } from 'shared/service';

export function useProductMassAction() {
  const { productService } = useService();
  const history = useHistory();
  const mutation = useMutation<void, Error | AxiosError, MassActionRevisedPriceProps>(
    request => productService.massActionRevisedPrice(request),
    {
      mutationKey: MUTATION_KEYS.massUpdateProduct,
      onSuccess: () => {
        history.push(ROUTES.products);
      },
      onError: () => {},
    }
  );

  return mutation;
}
